export default __webpack_public_path__ + "static/3-6bf56fb8745b207032e6d8a6cbdd8694.jpg";